// covered-by: frontends/carrie/src/utils/__tests__/logoutUrl.test.ts
import { loginRoute } from "../routes/login/route";

/**
 * Absolute login URL used after mid-session logout (classic AuthLayout and
 * Ask V2). Preserves a stored post-login `redirect` when present.
 */
export function logoutUrl(basepath: string): string {
  if (basepath === "/") basepath = "";
  const redirect = localStorage.getItem("redirect");
  const destination = new URL(location.origin + basepath + loginRoute.to);
  if (redirect) {
    destination.searchParams.append("redirect", redirect);
  }
  return destination.toString();
}
